<!-- 
Favourite button (loveheart icon)
-->
<template>
  <span>
    <v-tooltip v-if="canEdit" bottom>
      <v-btn 
        slot="activator" 
        icon small class="ma-0" 
        @click.stop="addRemoveFavourite(lcp)"
      >
        <v-icon :color="getFavouriteColour(lcp)" small>
          {{ getFavouriteIcon(lcp) }}
        </v-icon>
      </v-btn>
      <span>{{ lcp.favourite ? 'Click to remove from favourites' : 'Click to add to favourites' }}</span>
    </v-tooltip>
    <v-icon v-else :color="getFavouriteColour(lcp)" small>
      {{ getFavouriteIcon(lcp) }}
    </v-icon>
  </span>
</template>

<script>
import * as action from "@/store/levy-collection-providers/action-types";
import { LCP_TASK_FAVOURITE } from "@/store/claim-types";

export default {
  props: {
    lcp: {
      type: Object,
      required: true
    }
  },
  computed: {
    state() {
      return this.$store.state.levyCollectionProviders;
    },
    favourite() {
      return this.state.favourite;
    },
    taskProcessing() {
      return this.state.task.processing;
    },
    canEdit() {
      return this.$store.getters.claims.includes(LCP_TASK_FAVOURITE);
    }
  },
  methods: {
    async addRemoveFavourite(lcp) {
      if (!this.taskProcessing) {
        const data = {
          levyCollectionId: lcp.levyCollectionId,
          providerId: lcp.providerId,
          type: lcp.favourite ? "Unfavourite" : "Favourite"
        };
        await this.$store.dispatch(action.FAVOURITE_QUIETLY, data);
        this.$emit("changed");
      }
    },
    getFavouriteColour(lcp) {
      return lcp.favourite ? "pink" : "grey";
    },
    getFavouriteIcon(lcp) {
      return lcp.favourite ? "favorite" : "favorite_border";
    }
  }
};
</script>
